import type { ThemeConfig } from 'antd';
import { brand, typography } from './tokens';

/**
 * AntD ConfigProvider theme — brand Lanciano FC.
 * Override via `<ConfigProvider theme={antdTheme} />` in App.tsx.
 */
export function buildAntdTheme(b: { primary: string }): ThemeConfig {
  return {
  token: {
    colorPrimary: b.primary,
    colorError: brand.loss,
    colorSuccess: brand.win,
    colorWarning: brand.gold,
    colorInfo: brand.commerce,
    colorTextBase: brand.textPrimary,
    colorBgBase: brand.paper,
    colorBorder: brand.line,
    // Card/Modal/Drawer usano colorBorderSecondary + borderRadiusLG (non colorBorder/borderRadius
    // base) — senza questi due, le Card antd restano col bordo grigio e gli angoli di default (8px)
    // invece del bordo brand.line + radius 4px usato dal resto del BO (es. BOCard in Dashboard).
    colorBorderSecondary: brand.line,
    colorLink: b.primary,
    borderRadius: 4,
    borderRadiusLG: 4,
    fontFamily: `'Galano Grotesque', ${typography.backoffice}`,
    fontSize: 12,
  },
  components: {
    Button: {
      fontWeight: 700,
      primaryShadow: 'none',
    },
    Layout: {
      siderBg: '#FFFFFF',
      triggerBg: brand.inkSoft,
      headerBg: brand.ink,
      bodyBg: '#f2f0eb',
    },
    Menu: {
      darkItemHoverBg: brand.inkSoft,
      itemSelectedBg: '#fafaf7',
      itemSelectedColor: '#0b0b0d',
    },
    Table: {
      headerBg: brand.bgAlt,
      headerColor: brand.textSecondary,
      rowHoverBg: brand.bgAlt,
    },
  },
};
}

export const antdTheme = buildAntdTheme({ primary: brand.primary });
